import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation(['pages.privacy']);

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 relative">
      {/* Language Selector */}
      <div className="absolute top-4 right-4 z-10">
        <Select value={i18n.language} onValueChange={handleLanguageChange}>
          <SelectTrigger className="w-32 bg-white/90 backdrop-blur-sm">
            <Globe className="w-4 h-4 mr-2" />
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="en">EN</SelectItem>
            <SelectItem value="de">DE</SelectItem>
            <SelectItem value="tr">TR</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-bold">{t('pages.privacy:title')}</CardTitle>
            <p className="text-sm text-gray-600 mt-2">{t('pages.privacy:lastUpdated')}</p>
          </CardHeader>
          <CardContent className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.introduction.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.privacy:sections.introduction.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.dataCollection.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-3">{t('pages.privacy:sections.dataCollection.intro')}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t('pages.privacy:sections.dataCollection.items.name')}</li>
                <li>{t('pages.privacy:sections.dataCollection.items.email')}</li>
                <li>{t('pages.privacy:sections.dataCollection.items.organization')}</li>
                <li>{t('pages.privacy:sections.dataCollection.items.usage')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.dataUsage.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-3">{t('pages.privacy:sections.dataUsage.intro')}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t('pages.privacy:sections.dataUsage.items.service')}</li>
                <li>{t('pages.privacy:sections.dataUsage.items.communication')}</li>
                <li>{t('pages.privacy:sections.dataUsage.items.improvement')}</li>
                <li>{t('pages.privacy:sections.dataUsage.items.compliance')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.dataSharing.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.privacy:sections.dataSharing.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.dataSecurity.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.privacy:sections.dataSecurity.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.userRights.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-3">{t('pages.privacy:sections.userRights.intro')}</p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>{t('pages.privacy:sections.userRights.items.access')}</li>
                <li>{t('pages.privacy:sections.userRights.items.correction')}</li>
                <li>{t('pages.privacy:sections.userRights.items.deletion')}</li>
                <li>{t('pages.privacy:sections.userRights.items.portability')}</li>
                <li>{t('pages.privacy:sections.userRights.items.objection')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.cookies.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.privacy:sections.cookies.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.changes.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.privacy:sections.changes.content')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">{t('pages.privacy:sections.contact.title')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('pages.privacy:sections.contact.content')}</p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
